import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import moment from 'moment';

import { getNotificationMeta, isNotificationRead } from 'utils/notification';

import { NotificationIconCircle, NotificationItemWrapper, NotificationMessage } from './NotificationItem.styled';

function NotificationItem({ notification, onRead, readLoading = false, isExiting = false, showReadTooltip = true }) {
  const isRead = isNotificationRead(notification);
  const Classes = classNames({
    'omi-noti-block-container': true,
    'not-read': !isRead,
  });
  const { backgroundColor, icon: Icon } = getNotificationMeta(notification);
  const formattedCreatedAt = notification.created_at ? moment(notification.created_at).format('HH:mm DD/MM/YYYY') : '';

  return (
    <NotificationItemWrapper className={Classes} isExiting={isExiting}>
      <div className="flex gap-4 omi-noti-block items-center">
        <NotificationIconCircle className="omi-icon-circle-small" backgroundColor={backgroundColor}>
          <Icon />
        </NotificationIconCircle>
        <div className="flex-1 min-w-0">
          <NotificationMessage className="text-sm font-semibold" title={notification.message}>
            {notification.message}
          </NotificationMessage>
          <p className="text-xs text-grey-600 my-2">{formattedCreatedAt}</p>
        </div>
        {!isRead &&
          (showReadTooltip ? (
            <Tooltip title="Đánh dấu đã đọc">
              <Button
                type="text"
                size="small"
                htmlType="button"
                loading={readLoading}
                icon={<CheckOutlined />}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();

                  if (typeof onRead === 'function') {
                    onRead(notification);
                  }
                }}
              />
            </Tooltip>
          ) : (
            <Button
              type="text"
              size="small"
              htmlType="button"
              loading={readLoading}
              icon={<CheckOutlined />}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();

                if (typeof onRead === 'function') {
                  onRead(notification);
                }
              }}
            />
          ))}
      </div>
    </NotificationItemWrapper>
  );
}

export default NotificationItem;
